module.exports = __webpack_public_path__ + "static/media/email_2.6f354a05.png";